import lobby from './ViewLobby';
import sound from './ViewSound';
import author from './ViewAuthor';
import finish from './ViewFinish';
import loading from './ViewLoading';
export default { lobby, sound, author, finish, loading };